import React, { useState } from "react";
import { useLanguage } from "../../context/LanguageContext";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import emailjs from "emailjs-com";
import "react-toastify/dist/ReactToastify.css";

const EventRegistration = () => {
  const { t, currentLanguage } = useLanguage();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    consultationMode: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  let toastId = null;
  const displayToast = (message) => {
    if (!toast.isActive(toastId)) {
      toastId = toast(message, {
        closeOnClick: false,
        progressClassName: "toastProgress",
        toastId: "my_toast",
        autoClose: true,
        closeButton: false,
        position: "top-right",
      });
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // EmailJS configuration for event registration
    const templateParams = {
      name: formData.name,
      from_name: formData.name,
      message: `Regisztrált az eseményre!\nKonzultáció módja: ${formData.consultationMode}`,
      consultation_mode: formData.consultationMode,
      reply_to: formData.email,
      phone_number: formData.phone,
      site_name: "dubaiingatlan.ai",
      to_email: "hello@dubaiingatlan.ai",
      from_mail: "noreply@dubaiingatlan.ai",
    };

    emailjs
      .send(
        "service_o0hvyub",
        "template_w74zkao",
        templateParams,
        "user_LrB06JmtNSOzWeUdvPyEj"
      )
      .then(() => {
        setFormData({
          name: "",
          email: "",
          phone: "",
          consultationMode: "",
          message: "",
        });
        setIsSubmitting(false);
        navigate("/sikeres_urlapkitoltes");
      })
      .catch((error) => {
        displayToast(
          currentLanguage === "hu"
            ? "Hiba történt a regisztráció során. Kérjük, próbálja újra."
            : "An error occurred during registration. Please try again."
        );
        setIsSubmitting(false);
        console.log(error);
      });
  };

  return (
    <div className="event-registration-form">
      <form onSubmit={handleSubmit} className="registration-form">
        <div className="row registration-form-row">
          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="name">{t("event.registration.form.name")}</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                required
                className="form-control"
                placeholder={t("event.registration.form.namePlaceholder")}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="phone">
                {t("event.registration.form.phone")}
              </label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleInputChange}
                required
                className="form-control"
                placeholder={t("event.registration.form.phonePlaceholder")}
              />
            </div>
          </div>
        </div>

        <div className="row registration-form-row">
          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="email">
                {t("event.registration.form.email")}
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                required
                className="form-control"
                placeholder={t("event.registration.form.emailPlaceholder")}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="consultationMode">
                {t("event.registration.form.consultationMode")}
              </label>
              <select
                id="consultationMode"
                name="consultationMode"
                value={formData.consultationMode}
                onChange={handleInputChange}
                required
                className="form-control"
              >
                <option value="">
                  {t("event.registration.form.consultationModePlaceholder")}
                </option>
                <option value="Személyes">
                  {t("event.registration.form.consultationModeInPerson")}
                </option>
                <option value="On-line">
                  {t("event.registration.form.consultationModeOnline")}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div className="form-group text-center">
          <div className="header-btn">
            <button type="submit" className="btn" disabled={isSubmitting}>
              {isSubmitting
                ? t("event.registration.form.submitting")
                : t("event.registration.form.submit")}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default EventRegistration;
